import { AiFillHeart } from 'react-icons/ai';
import { FaMoneyBillWave, FaRegBuilding } from 'react-icons/fa';
import { MdOutlineCategory } from 'react-icons/md';
import { imgUrl } from '../../Helpers/Constant';
import { Link } from 'react-router-dom';
import { TPublicProductAndServiceList } from './apiEndpoints/pubAndSerTypes';

type IProps = {
  response: TPublicProductAndServiceList[] | undefined | null;
  checkVisitor?: (id: number, type: number) => void;
  getData?: (sEvent: TPublicProductAndServiceList) => void;
};
const CommonProductServiceCard = ({
  response,
  checkVisitor,
  getData,
}: IProps) => {
  return (
    <>
      {response?.length ? (
        <>
          <div
            className='grid-container'
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
              gap: '1rem',
              alignItems: 'start',
            }}
          >
            {response?.map((sEvent) => {
              return (
                <>
                  <div
                    className='grid-item'
                    key={sEvent.fair_member_product_id}
                    style={{
                      background: 'white',
                      height: '100%',
                      breakInside: 'avoid',
                      position: 'relative',
                      borderRadius: '5px',
                    }}
                  >
                    <span
                      style={{
                        position: 'absolute',
                        right: 10,
                        top: 10,
                        zIndex: 100,
                        cursor: 'pointer',
                        background: '#ffffff',
                        borderRadius: '50px',
                        padding: '3px',
                        border: `1px solid ${
                          sEvent.is_visitor_favorite
                            ? 'rgb(223 66 104)'
                            : 'gray'
                        }`,
                      }}
                      onClick={(e) => {
                        checkVisitor &&
                          checkVisitor(
                            sEvent.fair_member_product_id,
                            sEvent.is_visitor_favorite
                          );
                      }}
                    >
                      <AiFillHeart
                        size={25}
                        color={sEvent.is_visitor_favorite ? 'red' : 'gray'}
                      />
                    </span>

                    <div
                      className='events-card-bg w-100 h-100'
                      onClick={() => {
                        getData && getData(sEvent);
                      }}
                    >
                      <>
                        <div
                          className='event_wrapper'
                          style={{
                            height: '200px',
                            border: '1px solid #00ACEE',
                            borderTopRightRadius: '5px',
                            borderTopLeftRadius: '5px',
                          }}
                        >
                          <img
                            height={'197px'}
                            className='event-img'
                            alt={
                              (sEvent.fair_member_product_photo &&
                                sEvent?.fair_member_product_photo[0]) ||
                              ''
                            }
                            src={
                              sEvent.fair_member_product_photo
                                ? `${imgUrl}/${sEvent?.fair_member_product_photo[0]}`
                                : '/blank-image.png'
                            }
                          />
                        </div>

                        <div className='cardHeader fw-bold fs-5'>
                          <p className='px-2'>
                            {sEvent?.fair_member_product_name}
                          </p>
                        </div>
                      </>

                      <div>
                        <div
                          style={{
                            borderBottom: '1px solid gray',
                            borderRight: '1px solid gray',
                            borderLeft: '1px solid gray',
                            borderBottomRightRadius: '5px',
                            borderBottomLeftRadius: '5px',
                          }}
                          className='product_title d-flex flex-column gap-2'
                        >
                          <p
                            style={{
                              display: 'flex',
                              justifyContent: 'start',
                              alignItems: 'center',
                              gap: 3,
                            }}
                          >
                            <FaRegBuilding color='gray' size={15} />
                            <Link
                              to={`/product-services/exhibitor/details/${sEvent?.user_fair_member_id}`}
                              style={{ textDecoration: 'none' }}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <span
                                style={{
                                  color: '#b90000',
                                  cursor: 'pointer',
                                }}
                              >
                                {' '}
                                {sEvent.user_fair_member_company_name}
                              </span>
                            </Link>
                          </p>
                          <p
                            style={{
                              display: 'flex',
                              justifyContent: 'start',
                              alignItems: 'center',
                              gap: 3,
                            }}
                          >
                            <MdOutlineCategory color='gray' size={15} />
                            <span
                              style={{
                                color: '#3b2020',
                                lineHeight: 0.9,
                              }}
                            >
                              {' '}
                              {sEvent.fair_member_product_category}
                            </span>
                          </p>
                          <p
                            style={{
                              display: 'flex',
                              justifyContent: 'start',
                              alignItems: 'center',
                              gap: 3,
                            }}
                          >
                            <span>
                              <FaMoneyBillWave color='gray' size={15} />

                              <span
                                style={{
                                  color: '#3b2020',

                                  textDecoration: 'line-through',
                                }}
                              >
                                {' '}
                                Tk. {sEvent.fair_member_product_price}
                              </span>
                            </span>

                            <span>
                              <span
                                style={{
                                  color: '#3b2020',
                                }}
                              >
                                {' '}
                                Tk. {sEvent.fair_member_special_product_price}
                              </span>
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        </>
      ) : (
        <p className='text-center fs-4 fw-bold'>No event found</p>
      )}
    </>
  );
};

export default CommonProductServiceCard;
